module.exports = __webpack_public_path__ + "img/Logo_white.615d41a2.png";